import { motion } from "framer-motion";
import { useLangStore } from "@/store/lang.js";
import { PublicNav } from "@/components/PublicNav.js";
import { uiStrings } from "@bongeunsa/i18n";
import { usePageTitle } from "@/hooks/usePageTitle.js";

export function SurveyDonePage() {
  const { lang } = useLangStore();
  const s = uiStrings[lang];
  usePageTitle(s.site.surveyTitle);

  return (
    <div className="flex min-h-screen flex-col pt-3">
      <PublicNav lang={lang} />
      <div className="flex flex-1 flex-col items-center justify-center px-3 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex w-full flex-col items-center gap-6 rounded-2xl glass-card px-6 py-10 text-center"
        >
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-brand-50/80 ring-1 ring-brand-200/40">
            <svg viewBox="0 0 24 24" className="h-10 w-10 text-brand-500" fill="none" stroke="currentColor" strokeWidth={2}>
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-gray-900">{s.survey.doneTitle}</h1>
            <p className="text-sm text-gray-500">{s.survey.doneDesc}</p>
          </div>

          <a
            href="/"
            className="mt-2 rounded-xl bg-brand-500 px-8 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-600"
          >
            {s.survey.backHome}
          </a>
        </motion.div>
      </div>
    </div>
  );
}
